import {
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  SIGNOUT_USER_SUCCESS,
  SUCCESSFUL_CODE,
  OPENREG,
  SEND_2FA,
  USERDATA,
  AUTH_LOAD,
  AUTH_MESSAGE,
  AUTH_ACTION,
} from 'appRedux/constants';
import { clearSession, setSession } from 'appRedux/store/cookies';
import api, { setToken } from 'appRedux/api';
import _ from 'lodash';
import { redirectLogin } from 'routes/RedirectRoutes';
import { userSignInSuccess } from 'containers/Auth/Login/actions';
import {
  handleError,
  openNotificationWithIcon,
  openNotificationWithIconErr,
} from './Common';
import { navigate } from '@reach/router';
import Axios from 'axios';
export const showAuthMessage = message => ({
  type: SHOW_MESSAGE,
  payload: message,
});

export const hideMessage = () => ({
  type: HIDE_MESSAGE,
});

export const opennReg = value => ({
  type: OPENREG,
  payload: value,
});

export const saveUserData = value => ({
  type: USERDATA,
  payload: { userData: value },
});

export const setAuthLoad = value => ({
  type: AUTH_LOAD,
  payload: { authLoad: value },
});

export const setAuthMessage = value => ({
  type: AUTH_MESSAGE,
  payload: { authMessage: value },
});

export const setAuthAction = value => ({
  type: AUTH_ACTION,
  payload: value,
});

export const getMeWithToken = token => dispatch => {
  dispatch({ type: FETCH_START });
  const url = '/users/confirm';
  api
    .post(url, { token })
    .then(({ data }) => {
      // console.log('signUp: ', data);
      redirectLogin();
      /**
       * this need to be implemented
       */
      if (data.status && data.statusCode === SUCCESSFUL_CODE) {
        dispatch({ type: FETCH_SUCCESS, payload: true });
      } else {
        dispatch(
          handleError(_.isEmpty(data.message) ? 'Network Error' : data.message),
        ); // same as "FETCH_ERROR"
      }
    })
    .catch(error => {
      dispatch(handleError(error.message)); // same as "FETCH_ERROR"
    });
};

export const getUser = (callbackNeeded = false, callback) => dispatch => {
  // dispatch({ type: FETCH_START })
  const url = '/authentication/profile';
  api
    .get(url)
    .then(({ data }) => {
      dispatch(userSignInSuccess(data));
      dispatch({ type: FETCH_SUCCESS });
      // console.log('I am the one running always', data);
    })
    .catch(error => {
      dispatch(handleError(error.message)); // same as "FETCH_ERROR"
      callbackNeeded &&
        callback({ status: 'error', data: null, message: error.message });
      dispatch(userSignOut());
      redirectLogin();
      // console.log(error);
      dispatch({ type: FETCH_SUCCESS });
    });
};

export const userSignOut = () => dispatch => {
  const url = '/auth/logout';
  api
    .post(url)
    .then(({ data }) => {
      clearSession();
      dispatch({ type: FETCH_SUCCESS, payload: true });
      dispatch({ type: SIGNOUT_USER_SUCCESS });
      localStorage.removeItem('userData');
      redirectLogin();
    })
    .catch(error => {
      // console.log('');
    });
};

export const signUpUser = user => dispatch => {
  dispatch({ type: FETCH_START });

  const body = {
    ...user,
  };
  const url = 'auth/register';
  api
    .post(url, body)
    .then(({ data }) => {
      if (data.status === SUCCESSFUL_CODE) {
        dispatch(showAuthMessage(data.message));
        dispatch({ type: FETCH_SUCCESS, payload: true });
      } else {
        dispatch(
          handleError(_.isEmpty(data.message) ? 'Network Error' : data.message),
        ); // same as "FETCH_ERROR"
      }
    })
    .catch(error => {
      // console.log('Error', error);

      dispatch(handleError(error.data)); // same as "FETCH_ERROR"
    });
};

export const updateProfile = payload => dispatch => {
  dispatch({ type: FETCH_START });
  const url = '/customer/update-profile';
  api
    .post(url, payload)
    .then(({ data }) => {
      if (data.data) {
        // console.log('data dey', data.data);
        dispatch({ type: FETCH_SUCCESS, payload: true });
        openNotificationWithIcon(data.message, 'Profile', 'success');
        getProfile();
        // dispatch({ type: SAVE_FETCH_LGAS, payload: data.data });
      } else {
        dispatch(
          handleError(_.isEmpty(data.message) ? 'Network Error' : data.message),
        ); // same as "FETCH_ERROR"
      }
    })
    .catch(error => {
      if (error.data) {
        dispatch(handleError(error.data.errors)); // same as "FETCH_ERROR"
      } else {
        dispatch(handleError(error.message)); // same as "FETCH_ERROR"
      }
    });
};

export const updateProfilePicture = formData => dispatch => {
  dispatch({ type: FETCH_START });
  const url = '/customer/update-profile';

  // console.log(formData);
  api
    .post(url, formData)
    .then(({ data }) => {
      if (data.data) {
        // console.log('data dey', data.data);
        dispatch({ type: FETCH_SUCCESS, payload: true });
        openNotificationWithIcon(data.message, 'Profile', 'success');
        getProfile();
        // dispatch({ type: SAVE_FETCH_LGAS, payload: data.data });
      } else {
        dispatch(
          handleError(_.isEmpty(data.message) ? 'Network Error' : data.message),
        ); // same as "FETCH_ERROR"
      }
    })
    .catch(error => {
      // console.log('error', error.message);
      if (error.data) {
        dispatch(handleError(error.data.errors)); // same as "FETCH_ERROR"
      } else {
        dispatch(handleError(error.message)); // same as "FETCH_ERROR"
      }
    });
};

export const getProfile = () => dispatch => {
  dispatch({ type: FETCH_START });
  const url = '/authentication/profile';
  api
    .get(url)
    .then(({ data }) => {
      // console.log('profile Data: ', data);
      if (data.data) {
        const { data: loggedInUser } = data;
        dispatch({ type: FETCH_SUCCESS, payload: true });
        localStorage.setItem('userData', JSON.stringify(loggedInUser?.user));
      } else {
        dispatch(handleError(data.message ? data.message : 'Network Error')); // same as "FETCH_ERROR"
      }
    })
    .catch(error => {
      // console.log('error', error.message);
      if (error.data) {
        dispatch(handleError(error.data.errors)); // same as "FETCH_ERROR"
      } else {
        dispatch(handleError(error.message)); // same as "FETCH_ERROR"
      }
    });
};

//  two fa
export const send2faCode = (payload, cb, token, altUrl) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  return dispatch => {
    dispatch({ type: SEND_2FA, payload: { loader: true } });
    const url = altUrl
      ? altUrl
      : 'https://api.wevesti.com/api/twillo/phone/twilloSendCode';
    Axios.post(url, payload, config)
      .then(res => {
        openNotificationWithIcon(
          res.data.message,
          // `Sent code to your ${option}`,
          'Two Factored Authorization',
          'success',
        );
        dispatch({ type: SEND_2FA, payload: { loader: false } });
        setTimeout(() => {
          cb();
        }, 100);
      })
      .catch(error => {
        dispatch({ type: SEND_2FA, payload: { loader: false } });
        openNotificationWithIconErr(
          error.data.message,
          'Two Factored Authorization',
          'error',
        );
      });
  };
};

export const verify2faCode = (payload, from, token) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  return dispatch => {
    dispatch({ type: SEND_2FA, payload: { loader: true } });
    const url = 'https://api.wevesti.com/api/twillo/phone/twilloVerifyCode';
    Axios.post(url, payload, config)
      .then(res => {
        openNotificationWithIcon(
          'Authentication was successful.',
          // `Sent code to your ${option}`,
          'Two Factored Authorization',
          'success',
        );
        setToken(token);
        setSession(token);
        dispatch({ type: SEND_2FA, payload: { loader: false } });
        setTimeout(() => {
          navigate(from ? from : '/bank');
        }, 100);
      })
      .catch(error => {
        dispatch({ type: SEND_2FA, payload: { loader: false } });
        openNotificationWithIconErr(
          'Error occured while trying to validate your 2FA code, try again.',
          'Two Factored Authorization',
          'error',
        );
      });
  };
};

export const verify2faSignin = (payload, from, token) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  return dispatch => {
    dispatch({
      type: SEND_2FA,
      payload: { loader: true },
    });
    // const url =
    //   'syca-app-backend.eba-ay3dbsg7.us-east-1.elasticbeanstalk.com/authentication/confirm-2fa';
    const url = '/authentication/confirm-2fa';
    api
      .post(url, payload, config)
      .then(res => {
        openNotificationWithIcon(
          'Authentication was successful.',
          // `Sent code to your ${option}`,
          'Two Factored Authorization',
          'success',
        );
        setToken(token);
        setSession(token);
        dispatch({ type: SEND_2FA, payload: { loader: false } });
        setTimeout(() => {
          navigate(from ? from : '/bank');
        }, 100);
      })
      .catch(error => {
        dispatch({ type: SEND_2FA, payload: { loader: false } });
        openNotificationWithIconErr(
          error.data ? error.data.message : `Please contact help@wevesti.com'`,
          error.data ? error.data.message : 'Error Occurred',
          'error',
        );
      });
  };
};

// Register V2
export const signUpUserV1 = (payload, cb) => {
  return dispatch => {
    dispatch({
      type: AUTH_LOAD,
      payload: { authLoad: true, authMessage: '', authErr: '' },
    });
    const url = '/authentication/register';
    api
      .post(url, { ...payload, termsAndCondition: true })
      .then(res => {
        openNotificationWithIcon(res.data.message, 'Register', 'success');

        dispatch({
          type: AUTH_LOAD,
          payload: { authLoad: false, authMessage: res.data.message },
        });
        setTimeout(() => {
          cb(1);
        }, 100);
      })
      .catch(error => {
        dispatch({
          type: AUTH_LOAD,
          payload: { authLoad: false, authErr: error.data.message },
        });
        openNotificationWithIconErr(error.data.message, 'Register', 'error');
      });
  };
};

export const signUpUserV2 = (payload, cb) => {
  // console.log('creation Payload: ', payload);
  return dispatch => {
    dispatch({ type: AUTH_LOAD, payload: { authLoad: true, authMessage: '' } });
    const url = '/authentication/register';
    api
      .post(url, { ...payload, termsAndCondition: true })
      .then(res => {
        openNotificationWithIcon(res.data.message, 'Register', 'success');
        localStorage.setItem('userId', res.data.data.id);
        localStorage.setItem('token', res.data?.token);
        dispatch({
          type: AUTH_LOAD,
          payload: { authLoad: false, authMessage: '' },
        });
        setTimeout(() => {
          cb(1);
        }, 100);
      })
      .catch(error => {
        dispatch({
          type: AUTH_LOAD,
          payload: { authLoad: false, authMessage: error.data.message },
        });
        openNotificationWithIconErr(error.data.message, 'Register', 'error');
      });
  };
};

export const signUpUserP2V2 = (payload, cb) => {
  return dispatch => {
    dispatch({ type: AUTH_LOAD, payload: { authLoad: true, authMessage: '' } });
    const formData = new FormData();
    for (let key in payload) {
      //console.log(key);
      if (key === 'country') {
        formData.append(key, payload[key].label);
      } else {
        payload[key] && formData.append(key, payload[key]);
      }
    }
    // const url = '/auth/second-phase-register';
    const url = '/customer/update-profile';
    api
      .post(url, formData)
      .then(res => {
        openNotificationWithIcon(res.data.message, 'Account Update', 'success');
        dispatch({
          type: AUTH_LOAD,
          payload: { authLoad: false, authMessage: '' },
        });
        setTimeout(() => {
          cb(1);
        }, 100);
      })
      .catch(error => {
        dispatch({
          type: AUTH_LOAD,
          payload: { authLoad: false, authMessage: error.data.message },
        });
        openNotificationWithIconErr(
          error.data.message,
          'Account Update',
          'error',
        );
      });
  };
};

export const verifyNewUserAuthCode = (payload, cb) => {
  return dispatch => {
    dispatch({
      type: AUTH_LOAD,
      payload: { loader: true, authMessage: '', authErr: '' },
    });
    const url = '/authentication/verify-account-email';
    api
      .post(url, payload)
      .then(res => {
        openNotificationWithIcon(
          res.data.message,
          'Email Verification',
          'success',
        );
        dispatch({
          type: AUTH_LOAD,
          payload: { loader: false, authMessage: res.data.message },
        });
        localStorage.removeItem('userId');
        setTimeout(() => {
          cb(2);
        }, 100);
      })
      .catch(error => {
        // console.log(error.data.message)
        // console.log(error);
        dispatch({
          type: AUTH_LOAD,
          payload: {
            loader: false,
            authErr: error.data?.message ? error.data?.message : error,
          },
        });
        openNotificationWithIconErr(
          error.data.message,
          'Email Verification',
          'error',
        );
      });
  };
};

export const verifyUserPasswordAuthCode = (payload, cb) => {
  return dispatch => {
    dispatch({
      type: AUTH_LOAD,
      payload: { loader: true, authMessage: '', authErr: '' },
    });
    const url = '/authentication/forgot-password/confirm';
    api
      .post(url, payload)
      .then(res => {
        openNotificationWithIcon(
          res.data.message,
          'Email Verification',
          'success',
        );
        dispatch({
          type: AUTH_LOAD,
          payload: { loader: false, authMessage: res.data.message },
        });
        localStorage.removeItem('userId');
        setTimeout(() => {
          cb(2);
        }, 100);
      })
      .catch(error => {
        // console.log(error);
        // console.log(error.data.message)
        dispatch({
          type: AUTH_LOAD,
          payload: {
            loader: false,
            authErr: error.data?.message ? error.data?.message : error,
          },
        });
        openNotificationWithIconErr(
          error.data?.message,
          'Email Verification',
          'error',
        );
      });
  };
};

export const resendUserMail = payload => {
  return dispatch => {
    dispatch({ type: AUTH_LOAD, payload: { loader: true, authMessage: '' } });
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    };
    // const url = '/authentication/send-email-verification-code';
    const url =
      // 'https://api.wevesti.com/api/v1/authentication/send-email-verification-code';
      'https://syca-staging.wevesti.com/api/v1/authentication/send-email-verification-code';
    // 'syca-app-backend.eba-ay3dbsg7.us-east-1.elasticbeanstalk.com/api/v1/authentication/send-email-verification-code';

    http: Axios.post(url, payload, config)
      .then(res => {
        openNotificationWithIcon(
          res.data?.message,
          'Email Verification',
          'success',
        );
        dispatch({
          type: AUTH_LOAD,
          payload: { loader: false, authMessage: res.data.message },
        });
      })
      .catch(error => {
        dispatch({
          type: AUTH_LOAD,
          payload: { loader: false, authErr: error.data.message },
        });
        openNotificationWithIconErr(
          error.data?.message,
          'Email Verification',
          'error',
        );
      });
  };
};

export const resetPasswordV1 = (payload, cb) => {
  return dispatch => {
    dispatch({
      type: AUTH_LOAD,
      payload: { authLoad: true, authMessage: '', authErr: '' },
    });
    const url = '/authentication/forgot-password/update-password';
    api
      .post(url, payload)
      .then(res => {
        openNotificationWithIcon(res.data.message, 'Register', 'success');

        dispatch({
          type: AUTH_LOAD,
          payload: { authLoad: false, authMessage: res.data.message },
        });
        setTimeout(() => {
          cb();
        }, 100);
      })
      .catch(error => {
        dispatch({
          type: AUTH_LOAD,
          payload: { authLoad: false, authErr: error.data.message },
        });
        openNotificationWithIconErr(error.data.message, 'Register', 'error');
      });
  };
};
